import { type SVGProps, useId } from 'react'

export const Sparkle = (props: SVGProps<SVGSVGElement>) => {
	const gradId = useId()
	return (
		<svg
			width="19"
			height="18"
			viewBox="0 0 19 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<defs>
				<linearGradient
					id={gradId}
					x1="0.333008"
					y1="9"
					x2="20.0457"
					y2="9.02627"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FB9B8E" />
					<stop offset="0.9999" stopColor="#A78BFA" />
				</linearGradient>
			</defs>
			<path
				d="M12.6247 16.0833C12.3534 16.0833 12.1126 15.9079 12.0297 15.6496L10.8101 11.8562L7.01676 10.6367C6.75842 10.5537 6.58301 10.3129 6.58301 10.0417C6.58301 9.77042 6.75842 9.52958 7.01676 9.44667L10.8101 8.22708L12.0297 4.43375C12.1126 4.17542 12.3534 4 12.6247 4C12.8959 4 13.1368 4.17542 13.2197 4.43375L14.4393 8.22708L18.2326 9.44667C18.4909 9.52958 18.6663 9.77042 18.6663 10.0417C18.6663 10.3129 18.4909 10.5537 18.2326 10.6367L14.4393 11.8562L13.2197 15.6496C13.1368 15.9079 12.8959 16.0833 12.6247 16.0833ZM4.49967 8.58333C4.23051 8.58333 3.99176 8.41125 3.90676 8.15625L3.12009 5.79625L0.760091 5.00958C0.505091 4.92458 0.333008 4.68583 0.333008 4.41667C0.333008 4.1475 0.505091 3.90875 0.760091 3.82375L3.12009 3.03708L3.90676 0.677083C3.99176 0.422083 4.23051 0.25 4.49967 0.25C4.76884 0.25 5.00759 0.422083 5.09259 0.677083L5.87926 3.03708L8.23926 3.82375C8.49426 3.90875 8.66634 4.1475 8.66634 4.41667C8.66634 4.68583 8.49426 4.92458 8.23926 5.00958L5.87926 5.79625L5.09259 8.15625C5.00759 8.41125 4.76884 8.58333 4.49967 8.58333ZM3.87467 17.75C3.60551 17.75 3.36676 17.5779 3.28176 17.3229L2.65092 15.4317L0.760091 14.8012C0.505091 14.7162 0.333008 14.4775 0.333008 14.2083C0.333008 13.9392 0.505091 13.7004 0.760091 13.6154L2.65092 12.985L3.28176 11.0937C3.36676 10.8387 3.60551 10.6667 3.87467 10.6667C4.14384 10.6667 4.38259 10.8387 4.46759 11.0937L5.09801 12.985L6.98926 13.6154C7.24426 13.7004 7.41634 13.9392 7.41634 14.2083C7.41634 14.4775 7.24426 14.7162 6.98926 14.8012L5.09801 15.4317L4.46759 17.3229C4.38259 17.5779 4.14384 17.75 3.87467 17.75Z"
				fill={`url(#${gradId})`}
			/>
		</svg>
	)
}
